import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { painPoints, gainPoints } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function BeforeAfter() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:py-20" data-id="element-49" data-mp="26lure6opcs9a">
      <div className="mx-auto max-w-3xl" data-id="element-50" data-mp="26k9ysmly7je2">
        <h2 className="text-balance text-center font-display text-3xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-51" data-mp="22lka3xvgmff4">
          Arrêtez de douter chaque fois que vous allumez votre poste à souder
        </h2>

        <div className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-52" data-mp="2ud8kwfylatvu">
          <div className="rounded-2xl border border-red-500/25 bg-red-500/[0.06] p-5" data-id="element-53" data-mp="2qa3i0calkq6o">
            <p className="mb-4 inline-flex items-center gap-2 rounded-lg bg-red-500/15 px-3 py-1.5 text-xs font-extrabold uppercase tracking-[0.15em] text-red-300" data-id="element-54" data-mp="2lb92pkbu9jrb">
              Aujourd’hui…
            </p>
            <ul className="space-y-3.5" data-id="element-55" data-mp="19wdd53bnlxvz">
              {painPoints.map(item => <li key={item} className="flex gap-3" data-id="element-56" data-mp="19ygc4cusb1cu">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-57" data-mp="176npq1qgvj9n" />
                  <span className="text-[15px] leading-snug text-white/75" data-id="element-58" data-mp="y4o5z1o2i130">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-arc-500/30 bg-arc-500/[0.07] p-5" data-id="element-59" data-mp="1327ncag2atz6">
            <p className="mb-4 inline-flex items-center gap-2 rounded-lg bg-arc-500/20 px-3 py-1.5 text-xs font-extrabold uppercase tracking-[0.15em] text-arc-300" data-id="element-60" data-mp="oe32p0xg88dr">
              Avec le Système Maître…
            </p>
            <ul className="space-y-3.5" data-id="element-61" data-mp="fg140s16trtn">
              {gainPoints.map(item => <li key={item} className="flex gap-3" data-id="element-62" data-mp="jgba04ozci8i">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-arc-400" aria-hidden="true" data-id="element-63" data-mp="5ga6sil8sypv" />
                  <span className="text-[15px] font-medium leading-snug text-white" data-id="element-64" data-mp="aebpv3io4y1c">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10" data-id="element-65" data-mp="27bpsxf2ajm9c">
          <CtaBlock label="Je veux souder sans deviner" data-id="element-66" data-mp="23bfmk1al6tty" />
        </div>
      </div>
    </section>;
}